'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      type: 'line',
      height: 250,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    title: {
      text: '１日あたりの警報発生回数',
      style: { fontSize: '14px' }
    },
    xAxis: {
      crosshair: true,
      labels: {
        formatter: function () {
          let style = '';
          let day = scope.$filter('dayFilter')(this.value);
          if(day === '日') {
            style = 'color: #ff3131';
          } else if(day === '土') {
            style = 'color: #3737ff';
          }

          return `<span style="${style}">${scope.$filter('date')(this.value, 'M/d')} (${day})</span>`;
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: false
    },
    plotLines: [
      {
        id: 'target-date'
      }
    ],
    legend: {
      enabled: false
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function () {
        let tip_format = `<tspan style='font-size: 12px'>${scope.$filter('date')(this.x, 'M/d')} (${scope.$filter('dayFilter')(this.x)})</tspan>`;

        const pointError = this.points[0];
        tip_format += '<br/><span style="color:' + pointError.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + pointError.series.name + ': ';
        tip_format += pointError.y + " 回";
        tip_format += "</span>";

        return tip_format;
      }
    },
    plotOptions: {column: {grouping: false}},
    series: [
      {
        name: '警報発生回数',
        color: '#ff3535',
        marker: {enabled: false},
        lineWidth: 1,
        cursor: 'pointer'
      }
    ]
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/power-stat-graph/event/power-stat-graph-event.config.js